module.exports = __webpack_public_path__ + "img/loading-v2.df4f8245.svg";